import { render, staticRenderFns } from "./DashboardTableHeading.vue?vue&type=template&id=476024da&scoped=true&"
import script from "./DashboardTableHeading.vue?vue&type=script&lang=js&"
export * from "./DashboardTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTableHeading.vue?vue&type=style&index=0&id=476024da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476024da",
  null
  
)

export default component.exports